module.exports = __webpack_public_path__ + "static/media/staticmap.6cf9fa0f.png";